closeModalCustom();
function closeModalCustom () {
    jQuery( document ).on( 'click', '.close-modal-custom', function( event ) {
		elementorProFrontend.modules.popup.closePopup( {}, event );
	} );
}